import { DEFAULT_LOCALE, type Locale } from "@/lib/i18n/config"

/** Overrides de display por locale (shape guardado en items.translations). */
export type ItemTranslations = Record<
  string,
  { name?: string | null; description?: string | null } | null | undefined
>

type Translatable = {
  name: string
  description?: string | null
  translations?: ItemTranslations | null
}

/**
 * Texto de DISPLAY de un item para el locale dado.
 *
 * Las columnas base (`name`/`description`) son la fuente canónica y el contenido
 * del locale por defecto (`es`). `translations` guarda overrides por-locale; el
 * fallback es por-campo, así que un item a medio traducir se muestra mezclado
 * (nombre traducido + descripción base) sin romperse.
 *
 * IMPORTANTE: esto es SOLO para mostrar el menú al cliente. El nombre que va a la
 * orden/KDS/cocina siempre debe ser el canónico (`item.name`) — las rutas de
 * orden lo re-derivan del servidor por item_id, no del texto que envía el cliente.
 */
export function localizedItem<T extends Translatable>(
  item: T,
  locale: Locale,
): { name: string; description: string | null } {
  const base = { name: item.name, description: item.description ?? null }
  if (locale === DEFAULT_LOCALE || !item.translations) return base
  const t = item.translations[locale]
  if (!t) return base
  return {
    name: t.name?.trim() || base.name,
    description: t.description?.trim() || base.description,
  }
}
